import styled from '@emotion/styled'

export const MobileOnly = styled.div`
  display: none;
  ${({ theme }) => theme.breakpoints.down('md')} {
    display: block;
  }
`

export const DesktopOnly = styled.div`
  display: none;
  ${({ theme }) => theme.breakpoints.up('md')} {
    display: block;
  }
`
